/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select from "react-select";

// Argon Dashboard 2 PRO MUI base styles
import colors from "assets/theme/base/colors";

// Argon Dashboard 2 PRO MUI context
import { useArgonController } from "context";

// Custom styles for ArgonSelect
import styles from "components/ArgonSelect/styles";

const ArgonSelect = forwardRef(
  (
    {
      size,
      error,
      success,
      customize,
      disable,
      hasShadow,
      width,
      value,
      ...rest
    },
    ref
  ) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;
    const { light } = colors;

    return (
      <Select
        {...rest}
        value={value}
        ref={ref}
        isMulti={rest?.multiple}
        styles={styles(
          size,
          error,
          success,
          darkMode,
          customize,
          hasShadow,
          value?.width ?? width,
          disable
        )}
        menuShouldBlockScroll={false}
        isSearchable={true}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: light.main,
            primary: light.main,
          },
        })}
        isDisabled={disable}
      />
    );
  }
);

ArgonSelect.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
  customize: PropTypes.bool,
  disable: PropTypes.bool,
  hasShadow: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // e.g., "100%", "250px", 300
};

ArgonSelect.defaultProps = {
  size: "small",
  error: false,
  success: false,
  hasShadow: false,
  width: "100%",
};

export default ArgonSelect;
